import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    userId = '',
    beforeTime = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.userSignLog.clean, {
        userId,
        beforeTime,
    }, options);
    if (error) return { error, status };
    return content || {};
};

